import React, { useEffect, useState, useContext } from 'react'
import { CFormSwitch } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import moment from 'moment'
import DiscountCreationModal from './DiscountCreationModal'
import SearchTable from 'src/components/searchTable'
import { checkPermissions, raiseToast } from 'src/views/utils/helper'
import { GlobalContext } from '../../context/GlobalState'
import { PERMISSIONS } from '../../utils/permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import useAxios from 'axios-hooks'
import {
  SUBSCRIPTION_API,
  DISCOUNT_API,
  DISCOUNT_MASTER_API,
  SUBSCRIBER_API,
} from '../../utils/urls'
import { AppContext } from '../../context/app'

const Discount = (props) => {
  const { type } = props
  const { setLoader, accountObj } = useContext(AppContext)

  const [discountList, setDiscountList] = useState([])
  const language = localStorage.getItem('language')
  const [activeSubscription, setActiveSubscription] = useState([])
  const [subscribers, setSubscribers] = useState([])

  const [openModal, setOpenModal] = useState(false)
  const [selectedDisc, setSelectedDisc] = useState({})

  const { userSessionObj } = useContext(GlobalContext)
  const defaultLangCheck = language === accountObj?.default_language
  const createAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.DISCOUNT.CREATE) &&
    defaultLangCheck
  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.DISCOUNT.UPDATE,
  )

  const [{ data: discountDataList, loading: discountDataLoading }, discountListCall] = useAxios(
    {
      url: DISCOUNT_MASTER_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: subscriptionList, loading: subscriptionListLoading }, subscriptionListCall] =
    useAxios(
      {
        url: SUBSCRIPTION_API,
        method: 'get',
      },
      { manual: true },
    )
  const [{ data: subscriberList, loading: subscriberListLoading }] = useAxios({
    url: `${SUBSCRIBER_API}/list`,
    method: 'get',
  })

  const [{ data: createDiscount, loading: createDiscountLoading }, discountCreateCall] = useAxios(
    {
      url: DISCOUNT_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: updateDiscount, loading: updateDiscountLoading }, discountUpdateCall] = useAxios(
    {
      url: DISCOUNT_API,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    discountListCall({
      params: {
        discount_type: type,
      },
    })
    subscriptionListCall()
  }, [])

  useEffect(() => {
    setLoader(
      subscriberListLoading ||
        discountDataLoading ||
        subscriptionListLoading ||
        createDiscountLoading ||
        updateDiscountLoading,
    )
  }, [
    subscriberListLoading,
    discountDataLoading,
    subscriptionListLoading,
    createDiscountLoading,
    updateDiscountLoading,
  ])

  useEffect(() => {
    if (discountDataList && discountDataList.success) {
      let { data } = discountDataList
      let tempArr = []
      data.forEach((ele) => {
        let tempEle = ele
        tempEle[`valuePercent`] = `${ele.value} (${ele.value_type})`
        tempArr.push(tempEle)
      })
      setDiscountList(tempArr)
    }
  }, [discountDataList])

  useEffect(() => {
    if (subscriptionList && subscriptionList.success) {
      let { data } = subscriptionList
      setActiveSubscription(
        data
          .filter((sub) => sub.status)
          .map((item) => ({
            ...item,
            displayName: item.name + ` (${item.type === 'normal' ? 'Subscription' : 'PPV'})`,
          })),
      )
    }
  }, [subscriptionList])

  useEffect(() => {
    if (subscriberList && subscriberList.success) {
      setSubscribers(
        subscriberList.data
          .filter((item) => item.status)
          .map((info) => ({ ...info, displayName: `${info.name} (${info.email_id})` })),
      )
    }
  }, [subscriberList])

  useEffect(() => {
    if (createDiscount && createDiscount.success) {
      discountListCall({
        params: {
          discount_type: type,
        },
      })
      raiseToast('success', 'Discount created successfully')
    }
  }, [createDiscount])

  useEffect(() => {
    if (updateDiscount && updateDiscount.success) {
      discountListCall({
        params: {
          discount_type: type,
        },
      })
      raiseToast('success', 'Discount updated successfully')
    }
  }, [updateDiscount])

  const handleStatus = async (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    discountUpdateCall({
      params: {
        discount_id: info._id,
      },
      data: {
        status: !info.status,
      },
    })
  }
  const handleEdit = (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedDisc(info)
    setOpenModal(true)
  }

  const handleAdd = () => {
    if (!createAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedDisc({})
    setOpenModal(!openModal)
  }

  const addDiscount = (payload) => {
    discountCreateCall({
      data: payload,
    })
    setOpenModal(false)
  }

  const editDiscount = (payload, id) => {
    discountUpdateCall({
      params: {
        discount_id: id,
      },
      data: payload,
    })
    setOpenModal(false)
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 20,
    },
    {
      header: 'Value/Percentage',
      dataCell: (info) => info.valuePercent,
      width: 19,
    },
    {
      header: 'Max Discount',
      dataCell: (info) => info.max_value,
      width: 19,
    },
    {
      header: 'Edited On',
      dataCell: (info) => moment.utc(info.modified_date).format('DD-MM-YYYY'),
      width: 15,
    },
    {
      header: 'Status',

      dataCell: (info) => (
        <CFormSwitch
          label={info.status ? 'Active' : 'Disabled'}
          checked={info.status}
          valid={info.status}
          value={info.status}
          onChange={() => handleStatus(info)}
          size="lg"
        />
      ),
      width: 16,
    },
    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => (
        <CIcon
          icon={cilPencil}
          style={{ cursor: 'pointer' }}
          size="lg"
          title="Edit"
          onClick={() => handleEdit(info)}
        />
      ),
      width: 6,
    },
  ]

  const typeDiscountObj = {
    udisc: {
      name: 'User Specific Discount',
      description: 'It allow you to create user specific discounts',
    },
    uvouch: {
      name: 'User Specific Voucher',
      description: 'It allow you to create user specific vouchers',
    },
    disc: {
      name: 'Discount',
      description: 'It allow you to create discount',
    },
    vouch: {
      name: 'Voucher',
      description: 'It allow you to create voucher',
    },
  }
  return (
    <>
      <h4>{typeDiscountObj[type].name}</h4>
      <p>{typeDiscountObj[type].description}</p>
      <SearchTable
        type={typeDiscountObj[type].name}
        tableCardHeight={65}
        disableButton={false}
        buttonName={`+ ADD`}
        buttonFunction={handleAdd}
        searchTerm={`name`}
        tableContent={discountList}
        tableConfig={tableConfig}
        createPermission={createAllowed}
        disabledButtonTitle={
          defaultLangCheck ? '' : 'Adding Discount Available on Default Language'
        }
      />

      {openModal && (
        <DiscountCreationModal
          openModal={openModal}
          onCancel={() => setOpenModal(false)}
          subscription={activeSubscription}
          userList={subscribers}
          type={type}
          data={selectedDisc}
          createCallback={addDiscount}
          updateCallback={editDiscount}
        />
      )}
    </>
  )
}

export default Discount
